var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 46,
    viewBox: "0 0 62 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2774 45.0472H38.3529H35.6805H35.1033V31.7351H39.4571C40.5612 31.7351 41.2136 30.4805 40.5612 29.5771L32.0921 17.8585C31.5526 17.1057 30.436 17.1057 29.8965 17.8585L21.4275 29.5771C20.775 30.4805 21.4149 31.7351 22.5316 31.7351H26.8853V45.0472H26.3081H23.6357H12.1304C5.54335 44.6833 0.298828 38.5229 0.298828 31.8481C0.298828 27.2434 2.79562 23.2285 6.49689 21.0579C6.15813 20.142 5.98248 19.1634 5.98248 18.1345C5.98248 13.4295 9.78413 9.62787 14.4891 9.62787C15.5054 9.62787 16.4841 9.80352 17.4 10.1423C20.1226 4.3708 25.9945 0.368408 32.8199 0.368408C41.6527 0.380955 48.9298 7.14362 49.7579 15.7632C56.5456 16.93 61.7023 23.2159 61.7023 30.3299C61.7023 37.9332 55.7803 44.5202 48.2774 45.0472Z",
    fill: "#E2B024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.770808926ba04e1d3944419a5430eb46.svg";
export { ForwardRef as ReactComponent };